<div *ngIf="isContentfulActive">
  <ng-container *ngIf="content; else placeholderTemplate">
    <span [innerHtml]="content | safeContent : 'html'"></span>
  </ng-container>
  <ng-template #placeholderTemplate>
    <h1 *ngIf="placeholder" class="login-info__title placeholder">{{ placeholder }}</h1>
  </ng-template>
</div>
